<section>
	<div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="0px" fxLayoutGap.gt-sm="70px">
		<div fxFlex="auto" fxFlex.gt-sm="50%">
			<h3 i18n="@@TemplateSelectorTitle">Choose product template</h3>
			<p i18n="@@TemplateSelectorDescription"
				>After selecting a template you may change the product to your liking in the editor tool. Once
				you've finished with the product it's saved to your shopping cart. It can be later edited
				further.</p
			>
			@if (viewport.isMediumOrLarger$ | async) {
				<g-product-additional-info [product]="product" />
			}
		</div>
		<div fxFlex="auto" fxFlex.gt-sm="50%">
			<g-product-media-viewer
				[items]="imageUrls"
				[shownItem]="selectedThumbnailIndex"
				[isGridView]="true"
				(itemClicked)="onThumbnailClicked($event)"
			/>
		</div>
	</div>
</section>
